var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-block-editor find-contact" }, [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("automation.findContact"))),
        ]),
        _vm._v(" "),
        _c("AutomationContactSelector", {
          attrs: { "single-result-mode": "" },
          model: {
            value: _vm.clone.filterGroups,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "filterGroups", $$v)
            },
            expression: "clone.filterGroups",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }